import { Flex } from '@grupoboticario/flora-react';
import { MagnifyingGlassIcon } from '@grupoboticario/flora-react-icons';
import { HeaderSearch } from 'ui/components';
import { Text } from 'ui/components/primitives';
import { theme } from 'ui/theme';

type THeaderSearchResultEmpty = {
  query: string;
  focus: boolean;
};

const HeaderSearchResultEmpty = ({ query, focus }: THeaderSearchResultEmpty) => (
  <HeaderSearch.Empty data-testid="not-found" data-visible={focus}>
    <Flex justify="center">
      <MagnifyingGlassIcon css={{ color: theme.colors.action.nonInteractive.emphasis }} size="64" />
    </Flex>
    <HeaderSearch.Title level={6} textAlign="center">
      Nenhum resultado encontrado para {`"${query}"`}.
    </HeaderSearch.Title>
    <Text variant="body-large-standard" textAlign="center">
      Refaça a busca usando o nome do produto ou código
    </Text>
  </HeaderSearch.Empty>
);

export default HeaderSearchResultEmpty;
